import {
  CreateSecretRequest,
  PromptModel,
  Secret,
  UpdateSecretRequest,
  UpdateSecretValueRequest,
  WorkflowNode,
} from 'api/model';
import instance from '../axios_instance';

export const getProjectSecrets = async (projectId: string, includeGlobal: boolean): Promise<Secret[]> => {
  let url = `/projects/${projectId}/secrets`;
  if (includeGlobal) {
    url = `${url}?include_global=true`;
  }
  const response = await instance.get<Secret[]>(url);
  return response.data;
};

export const getGlobalSecrets = async (): Promise<Secret[]> => {
  const response = await instance.get<Secret[]>('/secrets');
  return response.data;
};

export const getSecret = async (id: string): Promise<Secret> => {
  const response = await instance.get<Secret>(`/secrets/${id}`);
  return response.data;
};

export const createSecret = async (model: CreateSecretRequest): Promise<Secret> => {
  const response = await instance.post<Secret>(`/secrets`, model);
  return response.data;
};

export const updateSecret = async (id: string, model: UpdateSecretRequest): Promise<Secret> => {
  const response = await instance.patch<Secret>(`/secrets/${id}`, model);
  return response.data;
};

export const updateSecretValue = async (id: string, model: UpdateSecretValueRequest): Promise<Secret> => {
  const response = await instance.patch<Secret>(`/secrets/${id}/value`, model);
  return response.data;
};

export const removeSecret = async (id: string) => {
  return await instance.delete(`/secrets/${id}`);
};

export const getNodesUsingSecret = async (secretId: string) => {
  const response = await instance.get<WorkflowNode[]>(`/secrets/${secretId}/nodes`);
  return response.data;
};

export const getModelsUsingSecret = async (secretId: string) => {
  const response = await instance.get<PromptModel[]>(`/secrets/${secretId}/models`);
  return response.data;
};
